import {
  GET
} from '@/axios/axios'

export const services = {
  PersonalProvide: (param) => { // 个人发放数据列表
    return GET("/backend/accountPaymentDetail/personalProvide", param);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/dataAnalysis.js